import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

import { Select } from '@/components';
import { Down } from '@/components/icons';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    value: {},
    disabled: { type: Boolean },
    dropdownWidth: {}
  },
  emits: ["update:value"],
  setup(__props: any, { emit }) {


const timeZoneData = require('./time-zone.json');
const SearchSelect = Select.Search;
const SelectOption = Select.Option;


const handleChange = (val: string) => {
  if (val !== undefined) {
    emit('update:value', val);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(SearchSelect), {
      value: _ctx.value,
      "dropdown-style": { maxHeight: '250px' },
      disabled: _ctx.disabled,
      "dropdown-width": _ctx.dropdownWidth,
      style: {"position":"relative"},
      onChange: handleChange
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeZoneData), (item) => {
          return (_openBlock(), _createBlock(_unref(SelectOption), {
            key: item.timeZoneDesc,
            value: item.timeZoneDesc
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.timeZoneShow) + ":00 " + _toDisplayString(item.timeZoneDesc), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["value", "disabled", "dropdown-width"]),
    _createVNode(_unref(Down), { class: "arrow" })
  ], 64))
}
}

})